<div class="p-6">
  <div class="mb-6 flex justify-between items-center">
    <h1 class="text-2xl font-bold text-gray-900">月次アーカイブデータ</h1>
    <button matIconButton (click)="archivesResource.reload()" aria-label="リロード" matTooltip="リロード">
      <mat-icon>refresh</mat-icon>
    </button>
  </div>

  <mat-card class="bg-primary-container">
    <mat-card-content class="p-0">
      
      @if (archivesResource.isLoading()) {
        <div class="p-8 flex justify-center items-center">
          <mat-spinner diameter="40"></mat-spinner>
        </div>
      } @else if (archivesResource.error()) {
        <div class="p-8 text-center text-red-600">
          <mat-icon class="text-4xl mb-2">error_outline</mat-icon>
          <p>アーカイブデータの取得に失敗しました。</p>
        </div>
      } @else if (archivesResource.value().length === 0) {
        <div class="p-8 text-center text-gray-500">
          <mat-icon class="text-4xl mb-2 opacity-50">folder_open</mat-icon>
          <p>ダウンロード可能なデータがありません。</p>
        </div>
      } @else {
        <div class="overflow-x-auto">
          <table mat-table [dataSource]="archivesResource.value()" class="w-full bg-transparent">

            <!-- Target Month Column -->
            <ng-container matColumnDef="targetMonth">
              <th mat-header-cell *matHeaderCellDef> 対象年月 </th>
              <td mat-cell *matCellDef="let element"> {{element.targetMonth}} </td>
            </ng-container>

            <!-- Site Name Column -->
            <ng-container matColumnDef="siteName">
              <th mat-header-cell *matHeaderCellDef> 現場名 </th>
              <td mat-cell *matCellDef="let element"> {{element.siteName}} </td>
            </ng-container>

            <!-- Size Column -->
            <ng-container matColumnDef="size">
              <th mat-header-cell *matHeaderCellDef> サイズ </th>
              <td mat-cell *matCellDef="let element"> {{formatBytes(element.size)}} </td>
            </ng-container>

            <!-- Updated At Column -->
            <ng-container matColumnDef="updatedAt">
              <th mat-header-cell *matHeaderCellDef> 最終更新日時 </th>
              <td mat-cell *matCellDef="let element"> {{element.updatedAt | date:'yyyy/MM/dd HH:mm'}} </td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef> </th>
              <td mat-cell *matCellDef="let element" class="text-right">
                <button matButton color="primary" 
                        (click)="downloadFile(element)" 
                        [disabled]="isDownloading()">
                  <span class="flex items-center gap-1">
                    @if (isDownloading() && downloadingPath() === element.fullPath) {
                      <mat-spinner diameter="20" class="inline-block"></mat-spinner>
                      <span>ダウンロード中...</span>
                    } @else {
                      <mat-icon>download</mat-icon>
                      <span>ダウンロード</span>
                    }
                  </span>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="hover:bg-black/5"></tr>
          </table>
        </div>
      }
    </mat-card-content>
  </mat-card>
</div>
